import React from 'react';
import { useState,useEffect } from "react";
import Swal from "sweetalert2";
import {Row,Col,Button} from "reactstrap";
import Sidebar from '../../Sidebar';
import { useNavigate } from 'react-router';
import RemarksStatusLine from '../../components/RemarksStatusLine';
import { useCookies } from 'react-cookie';
import { Link } from 'react-router-dom';
import {displayErrorToast,displayError,parseBoolean,findStateFromGstPortal,mapGstPortalCustomerFields,confirmGstPortalDetails} from '../../helpers';
import { createCustomerMain ,searchGstin} from "../../services/CustomerMainServices";
import ErrorToast from '../../ErrorToast';
import { getAllSalesRepresentatives } from '../../services/SalesRepresentativeServices';
import { getAllGroups } from "../../services/GroupFormServices";
import TableRowsCustomer from './TableRowsCustomer';
import { getIndianStates } from '../../utils/PicklistProvider';
import Select from 'react-select';
import EditSharpIcon from '@mui/icons-material/EditSharp';
import { getCurrentDate} from '../../utils/DateUtils';
import ListFormPageHeader from '../../components/ListFormPageHeader';
import {
  SiteDocCountCell,
  formatSiteAddress,
  formatSiteContact,
} from './SiteDocumentsModal';
import SitePincodeLocationFields from './SitePincodeLocationFields';
import { hasPermission, isSuperuser } from '../../utils/authSession';

function extractChildGroups(accountsGroupingList, parentName) {
  const list = accountsGroupingList || [];
  const parent = list.find((obj) => obj.entity_name === parentName);
  if (!parent) {
    return [];
  }
  return list
    .filter((obj) => obj.parent_id === parent.id)
    .sort((left, right) => String(left.entity_name || '').localeCompare(String(right.entity_name || '')));
}

function CustomerMain() {
  const [cookies] = useCookies(['myToken']);
  const [category] = useCookies(['myCategory']);
  const [superuser] = useCookies(['mySuperuser']);
  const canAddCustomer = isSuperuser(superuser) || hasPermission(category, 'add_entity_customer_detail');
  const canViewCustomerList = (
    isSuperuser(superuser)
    || hasPermission(category, 'view_entity_customer_detail')
    || hasPermission(category, 'change_entity_customer_detail')
    || hasPermission(category, 'delete_entity_customer_detail')
  );
  const [isChecked,setIsChecked] = useState({chkbx:false})
  const [inputs, setInputs] = useState({
      name: '',
      salesrep_id: '',
      address_1:'',
      address_2:'',
      address_3:'',
      pincode:'',
      state:'',
      phone_number: '',
      mobile_number:'',
      email_id:'',
      credit_limit:0,
      customer_type_id:'',
      opening_balance_amt:0,
      opening_balance_date:'',
      nature_of_business_id: '',
      is_interest_activated: 'true',
      is_bill_by_bill_maintained:'true',
      default_credit:0,
      registration_type:'Unknown',
      is_gst_set:'true',
      pan_no:'',
      gst_no:'',
      lut_no:'',
      tan_no:'',
      is_tcs_applicable:'false',
      is_tds_deductible:'false',
      contact_person:'',
      contact_designation:'',
      contact_mobile_no: '',
      contact_email_id:'',
      user_remarks:'',
      status: ''
  });
  const [error, setError] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(true);
  const navigate = useNavigate();
  const [natBusiness, setnatBusiness] = React.useState([]);
  const [groups, setGroups] = React.useState([]);
  const [salesRep, setsalesRep] = React.useState([]);
  const [CusMain,setCusMain] = React.useState([]);
  const [showModal, setShowModal] = useState(false);

  React.useEffect(() => {
    getAllSalesRepresentatives(cookies)
    .then (
        salesRepList => {
            const salesrep = salesRepList.salesrep_data.map(
              sales => {
                    return { value: sales.id, label: sales.entity_name }
                }
            );
            //console.log(JSON.stringify(salesRepList)+"salesRepList")
            salesrep.sort((a, b) => a.label.localeCompare(b.label));
            setsalesRep(salesrep);
        }
    )
  }, []);

  useEffect( () => {
    getAllGroups(cookies)
    .then(response => {
      const a = extractChildGroups(response?.accounts_grouping_list, 'CUSTOMER TYPE');
      setGroups(a);
      setInputs((values) => ({
        ...values,
        customer_type_id: a[0]?.id || values.customer_type_id || '',
        opening_balance_date: values.opening_balance_date || getCurrentDate(),
        state: values.state || getIndianStates()[31].value,
      }));
    })
    .catch((error) => {
      console.warn('Failed to load customer types:', error?.response?.data || error.message);
      setGroups([]);
    });
  }, []);

  useEffect( () => {
    getAllGroups(cookies)
      .then(response => {
      const a = extractChildGroups(response?.accounts_grouping_list, 'NATURE OF BUSINESS');
      setnatBusiness(a);
      setInputs((values) => ({
        ...values,
        nature_of_business_id: a[0]?.id || values.nature_of_business_id || '',
      }));
    })
    .catch((error) => {
      console.warn('Failed to load nature of business options:', error?.response?.data || error.message);
      setnatBusiness([]);
    });
  }, []);

  const [rowsData, setRowsData] = useState([]);
  const addTableRows = () => {
    const count=rowsData.length +1;
    const rowsInput={
      slNo:count,
      invoice_no: "",
      invoice_dt: "",
      invoice_amt: 0,
      payment_terms: 0,
      received_amt: 0,
      balance_amt: 0,
      mode: "debit"
    }
    setRowsData([...rowsData, rowsInput])
  }

  const deleteTableRows = (index)=>{
    const rows = [...rowsData];
    rows.splice(index, 1);
    for(var i=0; i<rows.length; i++) 
    {
        rows[i]['slNo']= i+1
    }
    setRowsData(rows);
  }

  const [siteData, setSiteData] = useState([]);
  const [siteInputs, setSiteInputs] = useState({});
  const [editIndex, setEditIndex] = useState(null); // null = add mode, number = edit mode
  const openAddModal = () => {
      setSiteInputs({site_name: '',
        address_1:'',
        address_2:'',
        address_3:'',
        plant_id:'',
        site_pincode:'',
        site_area:'',
        site_street:'',
        phone_number:'',
        mobile_number:'',
        site_email_id:'',
        radius_distance:0,
        estimated_travel_mins:0,
        project_name:'',
        salesrep_id: inputs.salesrep_id || '',
        contact_person:'',
        contact_designation: '',
        site_contact_email_id:'' ,
        user_remarks:'',
        contact_mobile_no:'',
        site_gst_no:'',
        site_pan_no:'',
        state:'',
        status: 'true'});
      setEditIndex(null);
      setIsChecked(values => ({chkbx:false}))
      setShowModal(true);
  }

  const handleChangeSite = (e) => {
    const { name, value } = e.target;
    setSiteInputs((prev) => ({ ...prev, [name]: value }));
  };

  const handleModalClose = () => {
    if (siteInputs.site_name && siteInputs.state && siteInputs.radius_distance>0 && siteInputs.project_name) {
      if (editIndex !== null) {
        // Edit mode
        const updated = [...siteData];
        updated[editIndex] = { ...siteInputs, sl_no: editIndex + 1 };
        setSiteData(updated);
      } 
      else {
        // Add mode
        setSiteData([...siteData, { ...siteInputs, sl_no: siteData.length + 1 }]);
      }
      setShowModal(false);
      setSiteInputs({site_name: '',
      address_1:'',
      address_2:'',
      address_3:'',
      plant_id:'',
      site_pincode:'',
      site_area:'',
      site_street:'',
      phone_number:'',
      mobile_number:'',
      site_email_id:'',
      radius_distance:0,
      estimated_travel_mins:0,
      project_name:'',
      salesrep_id: inputs.salesrep_id || '',
      contact_person:'',
      contact_designation: '',
      site_contact_email_id:'' ,
      user_remarks:'',
      contact_mobile_no:'',
      status: 'true',
      site_gst_no:'',
      site_pan_no:'',
      state:''});
    setEditIndex(null);
    }
    else{
      Swal.fire("Name, State, Plant distance, and Project name are mandatory.", "", "info");
    }
    
  };

  const openEditModal = (index) => {
    const site = siteData[index] || {};
    setSiteInputs({
      ...site,
      plant_id: site.plant_id || '',
      site_area: site.site_area || '',
      site_street: site.site_street || '',
      site_pincode: site.site_pincode || site.pincode || '',
      estimated_travel_mins: site.estimated_travel_mins || 0,
      salesrep_id: site.salesrep_id || site.salesrep?.id || inputs.salesrep_id || '',
    });
    setEditIndex(index);
    setIsChecked(values => ({chkbx:false}))
    setShowModal(true);
  };

  const deleteTableSiteRows = (index)=>{
    const rows = [...siteData];
    rows.splice(index, 1);
    rows.forEach((row, idx) => (row.sl_no = idx + 1));
    setSiteData(rows);
  }

  const handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    try{
      if(name == 'name') //Customer name must not be empty ,it is already exist then create a new customer name
      {
        if(!value.trim())
        {
          setError(values => ({...values, [name]: "Customer Name must not be empty..."}))
          setIsSubmitting(false); 
        }
        else
        {
          var err=0;
          for(var i=0; i<(CusMain.length); i++)
          {
            if(CusMain[i].name === value.trim().toUpperCase())
            {
              setError(values => ({...values, [name]: "Given Customer Name already exists..Please give new one.."}))
              setIsSubmitting(false);
              var err= 1;
              break;
            }
          }
          if(err === 0)
          {
            setError(values => ({...values, [name]: ''}))
            setIsSubmitting(true);
          }
        }
      }
      setInputs(values => ({...values, [name]: event.target.value}))
    }
    catch (e)
    {
      displayErrorToast(e);
    }
  }

  const handleInvoice = (index, evnt)=>{
    const { name, value } = evnt.target;
    const rowsInput = [...rowsData];
    rowsInput[index][name] = value;
    if(name === 'invoice_amt')
    {
      console.log(JSON.stringify(name)+"name")
      var amount=value-rowsInput[index]['received_amt']
      rowsInput[index]['balance_amt']= amount//.toFixed(2)
      console.log(JSON.stringify(rowsInput)+"rowsInput")
      var grandTotal = 0;
      for(var i=0; i<rowsData.length; i++) 
      {
        if((rowsData[i].balance_amt) == '') 
        {
            rowsData[i].balance_amt=0 
        }
        grandTotal += parseFloat(rowsData[i].balance_amt)
      }
    }
    else if(name === 'received_amt')
    {
      var amount=rowsInput[index]['invoice_amt']-value
      rowsInput[index]['balance_amt']= amount
      var grandTotal = 0;
      for(var i=0; i<rowsData.length; i++) 
      {
        if((rowsData[i].balance_amt) == '') 
        {
            rowsData[i].balance_amt=0
        }
        grandTotal += parseFloat(rowsData[i].balance_amt)
      }
    }
    setRowsData(rowsInput);
  }
    
  const validate_items = (name,value,regular_expr,error_message,obj) =>
  {
    try{
      if(value.trim())
      {
          if(!regular_expr.test(value.trim()))
          {
              setError(values => ({...values, [name]: error_message}))
              setIsSubmitting(false); 
          }
          else
          {
              setError(values => ({...values, [name]: ''}))
              setIsSubmitting(true);
          }
      }
      else
      {
          setError(values => ({...values, [name]: ''}))
          setIsSubmitting(true);
      }
      const fieldValue = (name === 'gst_no' || name === 'site_gst_no') ? value.toUpperCase() : value;
      obj(values => ({...values, [name]: fieldValue}))
      if((name==='gst_no')&&(fieldValue.length === 15))
      {
        try {
          searchGstin(cookies, fieldValue.trim())
          .then( async data => {
            console.log(JSON.stringify(data)+"response data");
            if (data.success && data.result) {
              const confirmed = await confirmGstPortalDetails(data);
              if (!confirmed) {
                return;
              }
              const mapped = mapGstPortalCustomerFields(data.result);
              const st = findStateFromGstPortal(mapped.stcd, getIndianStates());
              setInputs(prev => ({
                ...prev,
                name: mapped.name,
                address_1: mapped.address_1,
                address_2: mapped.address_2,
                address_3: mapped.address_3,
                pincode: mapped.pincode,
                state: st?.value || '',
                gst_status: mapped.gst_status,
                registration_type: mapped.registration_type,
              }));
            }
            else{
              Swal.fire(data.message || 'Could not fetch GST details', `GST NO: ${fieldValue}`, 'info')
            }
          })
          .catch((error) =>
          {
            displayError(error," Failed");
          })
        } 
        catch (err) 
        {
            console.error("Error fetching GST details", err);
            alert("Invalid or unreachable GST details.");
        }
      }
    }
    catch (e)
    {
      displayErrorToast(e);
    }
  }  
     
  const handleSubmit=(event)=> {
    event.preventDefault(); 
    if ((Object.values(error).every(x => !x)) && isSubmitting && siteData.length>0) //If all the required fields are field u can select the save button then choose the option yes or no
    {
      Swal.fire({title:  (inputs.gst_status && inputs.gst_status != 'Active'?`Customer GST status is ${inputs.gst_status} .` : '') + 'Do you want to save?',  
        showCancelButton: true,  
        confirmButtonText: `Yes`,  
        cancelButtonText: `No`,
      }).then((result) => {  
        if (result.isConfirmed) { 
          console.log(JSON.stringify(siteData)+"siteData");
          console.log(JSON.stringify(inputs)+"inputs submit");
            createCustomerMain(cookies, {
              gst_status:inputs.gst_status,
              name:inputs.name,
              salesrep_id:inputs.salesrep_id,
              address_1:inputs.address_1,
              address_2:inputs.address_2,
              address_3:inputs.address_3,
              pincode:inputs.pincode,
              state: inputs.state,
              phone_number: inputs.phone_number,
              mobile_number:inputs.mobile_number,
              email_id:inputs.email_id,
              credit_limit:inputs.credit_limit,
              opening_balance_amt:parseFloat(inputs.opening_balance_amt),    
              opening_balance_date:inputs.opening_balance_date,
              customer_type_id:inputs.customer_type_id,
              nature_of_business_id: inputs.nature_of_business_id,
              is_interest_activated:parseBoolean(inputs.is_interest_activated),
              is_bill_by_bill_maintained:parseBoolean(inputs.is_bill_by_bill_maintained),
              default_credit:inputs.default_credit,
              registration_type:inputs.registration_type,
              is_gst_set:parseBoolean(inputs.is_gst_set),
              pan_no:inputs.pan_no,
              gst_no:inputs.gst_no,
              lut_no:inputs.lut_no,
              tan_no:inputs.tan_no,
              is_tcs_applicable:parseBoolean(inputs.is_tcs_applicable),
              is_tds_deductible:parseBoolean(inputs.is_tds_deductible),
              contact_person:inputs.contact_person,
              contact_designation: inputs.contact_designation,
              contact_mobile_no: inputs.contact_mobile_no,
              contact_email_id:inputs.contact_email_id,
              user_remarks:inputs.user_remarks,
              ob_details_list:rowsData.map(cuslist=>({
                id:cuslist.id,
                invoice_no:cuslist.invoice_no,
                invoice_dt:cuslist.invoice_dt,
                invoice_amt:parseInt(cuslist.invoice_amt),
                payment_terms:cuslist.payment_terms,
                received_amt:cuslist.received_amt,
                balance_amt:cuslist.balance_amt,
                mode:cuslist.mode
              })),
              site_list:siteData.map(site=>({
                name: site.site_name.trim().toUpperCase(),
                address_1:site.address_1,
                address_2:site.address_2,
                address_3:site.address_3,
                pincode:site.site_pincode,
                phone_number:site.phone_number,
                mobile_number:site.mobile_number,
                email_id:site.site_email_id,
                radius_distance:site.radius_distance,
                estimated_travel_mins:site.estimated_travel_mins || 0,
                project_name:site.project_name,
                salesrep_id: site.salesrep_id || inputs.salesrep_id || '',
                contact_person:site.contact_person,
                contact_designation: site.contact_designation,
                contact_email_id: site.site_contact_email_id,
                user_remarks:site.user_remarks,
                contact_mobile_no:site.contact_mobile_no,
                status: parseBoolean(site.status),
                state:site.state,
                gst_no:site.site_gst_no?site.site_gst_no:'',
                pan_no:site.site_pan_no?site.site_pan_no:''
              })),
              status:parseBoolean(inputs.status)
            })
          .then(response => {
              Swal.fire("Saved!", "", "success");
              Reload();
          }).catch((error) => {
              console.log(error.response.data+"error.response.data");
              displayError(error.response.data,"Saved Failed");
          });
        } 
        else if (result.isDismissed) 
        {    
          Swal.fire('Not saved', '', 'info')  
        }
      });
    }
    else if(siteData.length==0){
      Swal.fire("Atleast 1 site must be added", "", "info");
    }
  }
  
  const handleCopyDetails = (event) => {
    const name = event.target.name;
    const value = event.target.checked;
    try{    
      if(value === true){
        setIsChecked(values => ({chkbx:true}))
        setSiteInputs(values =>({...values,
        ['site_name']: inputs.name,
        ['address_1']:inputs.address_1,
        ['address_2']:inputs.address_2,
        ['address_3']:inputs.address_3,
        ['site_pincode']:inputs.pincode,
        ['phone_number']:inputs.phone_number,
        ['mobile_number']:inputs.mobile_number,
        ['site_email_id']:inputs.email_id,
        ['site_pan_no']:inputs.pan_no,
        ['site_gst_no']:inputs.gst_no,
        ['state']:inputs.state
        }))
      }
      else
      {
        const emptyvalues = {
          site_name: '',
          address_1:'',
          address_2:'',
          address_3:'',
          site_pincode:'',
          phone_number:'',
          mobile_number:'',
          site_email_id:'',
          site_pan_no:'',
          site_gst_no:'',
          state:''
        };
        setIsChecked(values => ({chkbx:false}))
        setSiteInputs(values => ({...values, ...emptyvalues}));
      }
    } 
    catch(e)
    {
      displayErrorToast(e);
    }  
  }

  const Reload = () => {
    window.location.reload();
  }    

  const view = () => {
    navigate('/CustomerMainTable')
  }  

  const Back = () => {
    navigate('/Home')
  }
  
  const Cancel = () => {
    setInputs({
      name: '',
      salesrep_id: '',
      address_1:'',
      address_2:'',
      address_3:'',
      pincode:'',
      state:'',
      phone_number: '',
      mobile_number:'',
      email_id:'',
      credit_limit:0,
      customer_type_id:'',
      opening_balance_amt:0,
      opening_balance_date:'',
      nature_of_business_id: '',
      is_interest_activated: 'true',
      is_bill_by_bill_maintained:'true',
      default_credit:0,
      registration_type:'Unknown',
      is_gst_set:'true',
      pan_no:'',
      gst_no:'',
      lut_no:'',
      tan_no:'',
      is_tcs_applicable:'false',
      is_tds_deductible:'false',
      contact_person:'',
      contact_designation:'',
      contact_mobile_no: '',
      contact_email_id:'',
      user_remarks:'',
      status: ''
    });
  }
  
  const [selectedSalesrep, setselectedSalesrep] = useState(null);
  const onSalesrepSelect = (selected) => {
      setselectedSalesrep(selected);
      setInputs(values => ({...values,['salesrep_id']:selected.value}))
  };

  return (
    <>
      <div id="outer-container"  className="App" > 
        <Sidebar pageWrapId={'page-wrap'} outerContainerId={'outer-container'} />
        <ErrorToast/>
        <div id="page-wrap">
          <ListFormPageHeader
            module="MARKETING"
            title="Customer Registration"
            subtitle="Register a new customer with billing and contact details."
            modeLabel="CREATE MODE"
            showFloatingControls={false}
          />
          <div className="list-form-page-shell">
          <form onSubmit={handleSubmit}> 
            <div className="floating-button-bar">
              <div className="social-btn"  >   
                <ul className="text-center" style={{flexDirection: "column"}}>
                  {canAddCustomer &&(
                    <li className="text-center">
                      <button type="submit" className="facebook" style={{borderColor:"transparent"}} title="SAVE">
                      <i className="fa fa-floppy-o"></i><i className="fa fa-floppy-o"></i>
                      </button>
                    </li>
                  )} &nbsp;&nbsp;
                    
                  {canAddCustomer &&(
                    <li className="text-center">
                      <Link to="" onClick={Cancel} className="facebook" title="CANCEL / RESET">
                      <i className="fa fa-ban"></i><i className="fa fa-ban"></i>
                      </Link>
                    </li> 
                  )}&nbsp;&nbsp;

                  {canViewCustomerList &&(  
                    <li className="text-center">
                      <Link to={'/CustomerMainTable'} className="facebook" title="VIEW LIST">
                      <i className="fa fa-eye"></i><i className="fa fa-eye"></i>
                      </Link>
                    </li> 
                  )}&nbsp;&nbsp;
                  
                  <li className="text-center">
                    <Link  to={'/Home'} className="facebook" title="HOME">
                    <i className="fa fa-home"></i><i className="fa fa-home"></i>
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            
            <div className="form-content-wrap customer-page"> 
              <Row className="form-equal-height-row"> 
                <Col xl={6} lg={12} md={12}>   
                  <div className="form-row table-bordered shadow p-2 my-2 border-secondary p-2 mb-3 bg-blue form-control-panel form-panel-fill" >
                    <h5 className='col-sm-11'><b>Customer Details</b></h5><br/><br/>     
                      <label htmlFor="name" className="form-group col-sm-4 text-right">Name </label>
                      <input type="text" name="name" id="name" className="form-control col-sm-7 mandatory-form-control" required onChange={handleChange} value={inputs.name || ""} placeholder="Enter fill the name field*"   maxLength="100" /><br/>
                      {error.name && (<><strong className="form-group col-sm-12 text-center text-danger" >{error.name}</strong><br/></>)}

                      <label htmlFor="salesrep_id" className="form-group col-sm-4 text-right">Marketing Name </label>
                      <div style={{width: '58%'}} >
                      <Select
                        id="salesrep_id"
                        options={salesRep}
                        isMulti= {false}
                        isSearchable={true}
                        value={selectedSalesrep}
                        onChange={onSalesrepSelect}
                        className={"mandatory-form-control react-select-dropdown"}
                      />
                      </div> 
                      <br/>
                                
                      <label htmlFor="address_1" className="form-group col-sm-4 text-right">Address</label>
                      <input type="text" name="address_1" id="address_1" className="form-control col-sm-7" onChange={handleChange} value={inputs.address_1 || ""}/><br/>
                      
                      <label htmlFor="address_2" className="form-group col-sm-4 text-right"></label>
                      <input type="text" name="address_2" id="address_2" className="form-control col-sm-7" onChange={handleChange} value={inputs.address_2 || ""}/><br/>
                      
                      <label htmlFor="address_3" className="form-group col-sm-4 text-right"></label>
                      <input type="text" name="address_3" id="address_3" className="form-control col-sm-7" onChange={handleChange} value={inputs.address_3 || ""}/><br/>                                       
                                
                      <label htmlFor="pincode"className="form-group col-sm-4 text-right">Pin Code</label>
                      <input name="pincode" id="pincode" onChange={ (event) => validate_items(event.target.name,event.target.value,/^[1-9][0-9]{5}$/,"invalid Pincode",setInputs)} value={inputs.pincode || ""} className="form-control col-sm-7" type = "text" maxLength="6"/><br/>
                      {error.pincode && (<><strong className="form-group col-sm-12 text-center text-danger" >{error.pincode}</strong><br/></>)}

                      <label htmlFor="state"className="form-group col-sm-4 text-right">State</label>
                      <select id="state"name="state" className="browser-default custom-select form-control col-sm-7 mandatory-form-control" onChange={handleChange} required value={inputs.state || ""}>
                        <option value="">Select State</option>
                        {
                          getIndianStates()
                          .map(indian_state => <option key={indian_state.value} value={indian_state.value}>{indian_state.name}</option>
                          )
                        }
                      </select>

                      <label htmlFor="phone_number" className="form-group col-sm-4 text-right">Phone No</label>
                      <input type="text" name="phone_number" id="phone_number" className="form-control col-sm-7" onChange={handleChange} value={inputs.phone_number || ""}placeholder="0123456789, 0123456789" /><br/>
                      
                      <label htmlFor="mobile_number" className="form-group col-sm-4 text-right">Mobile No</label>
                      <input type="text" name="mobile_number" id="mobile_number" className="form-control col-sm-7"  onChange={handleChange} value={inputs.mobile_number || ""} placeholder="0123456789, 0123456789"/><br/>
                      
                      <label htmlFor="email_id" className="form-group col-sm-4 text-right">Email</label>
                      <input type="email" name="email_id" id="email_id" className="form-control col-sm-7"  onChange={ (event) => validate_items(event.target.name,event.target.value,/^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/,"invalid Emailid",setInputs)} value={inputs.email_id|| ""} /><br/>
                      {error.email_id && (<><strong className="form-group col-sm-12 text-center text-danger" >{error.cusEmailid}</strong><br/></>)}

                      <label htmlFor="credit_limit" className="form-group col-sm-4 text-right">Credit Limit(in Rs.)</label>
                      <input type="number" name="credit_limit" id="credit_limit" onChange={handleChange} value={inputs.credit_limit || 0} className="form-control col-sm-7"/>

                      <div className="customer-opening-balance-line">
                        <label htmlFor="opening_balance_amt">Opening Balance</label>
                        <input type="number" name="opening_balance_amt" id="opening_balance_amt" onChange={handleChange} value={inputs.opening_balance_amt || 0} className="form-control mandatory-form-control"/>
                        <button type="button" className="btn btn-primary text-blue text-bold" data-toggle="modal" data-target="#exampleModalCenter">Details</button>
                        <label htmlFor="opening_balance_date">Date</label>
                        <input type="date" id="opening_balance_date" name="opening_balance_date" onChange={handleChange} value={inputs.opening_balance_date || ""} className="form-control" />
                      </div>
                        <div className="modal fade" id="exampleModalCenter" tabIndex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                          <div className="modal-dialog modal-lg" style={{height: "500px"}} >
                            <div className="modal-content">
                                <div className="modal-body display">
                                  <table id="example mytable" className="table-responsive">
                                    <thead>
                                      <tr>                                                    
                                        <th><button type="button"className="btn btn-success" onClick={addTableRows}>+</button></th>
                                        <th colSpan="1">S.No.</th>
                                        <th colSpan="1">Invoice No</th>
                                        <th colSpan="1" style={{width:"120px"}}>Invoice Date</th>
                                        <th colSpan="1">Invoice Amount</th>
                                        <th colSpan="1">Payment Terms</th>
                                        <th colSpan="1">Received Amount </th>
                                        <th colSpan="1">Balance Amount</th>
                                        <th colSpan="1">Mode</th>
                                      </tr>
                                    </thead>
                                    <tbody id="tbodymodal">
                                      <TableRowsCustomer rowsData={rowsData} deleteTableRows={deleteTableRows} handleInvoice={handleInvoice} />
                                    </tbody>
                                  </table>
                                </div>
                            </div>
                          </div>
                        </div>
                  </div>
                        
                  <div className="form-row table-bordered shadow p-2 my-2 border-secondary p-2 mb-3 bg-blue form-control-panel form-panel-fill" >
                    <h5 className='col-sm-11'><b>Customer Type Details</b></h5><br/><br/> 
                    <label htmlFor="customer_type_id" className="form-group col-sm-4 text-right">Customer Type </label>
                    <select id="customer_type_id" name="customer_type_id" onChange={handleChange} value={inputs.customer_type_id || ""} className="browser-default custom-select form-control col-sm-7" >
                        <option value="">Select Cutomer Type</option>
                        {groups.map((item) => (
                        <option key={item.id} value={item.id}>
                        {item.entity_name}
                        </option>
                    ))}
                    </select><br/>
              
                    <label htmlFor="nature_of_business_id" className="form-group col-sm-4 text-right">Nature of Business </label>
                    <select name="nature_of_business_id" id="nature_of_business_id" onChange={handleChange} value={inputs.nature_of_business_id || ""} className="browser-default custom-select form-control col-sm-7" >
                        <option value="">Select Customer's Nature of Business </option>
                        {natBusiness.map((item) => (
                        <option key={item.id} value={item.id}>
                        {item.entity_name}
                        </option>
                    ))}
                    </select><br/>

                    <label htmlFor="default_credit" className="form-group col-sm-4 text-right">Credit(in Days)</label>
                    <input type="number" name="default_credit" id="default_credit" onChange={handleChange} value={inputs.default_credit || 0} className="form-control col-sm-7"/><br/>
                  </div>
                </Col>
                
                <Col xl={6} lg={12} md={12}>   
                  <div className="form-row table-bordered shadow p-2 my-2 border-secondary p-2 mb-3 bg-blue form-control-panel form-panel-fill" >
                    <h5 className='col-sm-11'><b>Statutory Details</b></h5><br/><br/> 
                    <label htmlFor="registration_type" className="form-group col-sm-4 text-right">GST Type </label>
                    <select name="registration_type" id="registration_type" onChange={handleChange} value={inputs.registration_type || ""} className="browser-default custom-select form-control col-sm-7 mandatory-form-control"  required>
                      <option value="Unknown">Unknown</option>
                      <option value="Composition">Composition</option>
                      <option value="Consumer">Consumer</option>
                      <option value="Regular">Regular</option>
                      <option value="Unregistered">Unregistered</option>
                    </select><br/>

                    <label htmlFor="is_gst_set" className="form-group col-sm-4 text-right">Set/Alter GST details</label>
                    <select name="is_gst_set" id="is_gst_set" onChange={handleChange} value={inputs.is_gst_set} className="browser-default custom-select form-control col-sm-7 mandatory-form-control"  required>
                      <option value="">Please select</option> 
                      <option value="false">No</option>
                      <option value="true">Yes</option>
                    </select><br/>
                            
                    <label htmlFor="pan_no" className="form-group col-sm-4 text-right">PAN No.</label>
                    <input type="text"name="pan_no" id="pan_no" className="form-control col-sm-7" onChange={ (event) => validate_items(event.target.name,event.target.value,/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,"invalid PANNo",setInputs)}  value={inputs.pan_no || ""}  placeholder="Please fill the PAN field *"  /><br/>
                    {error.pan_no && (<><strong className="form-group col-sm-12 text-center text-danger" >{error.pan_no}</strong><br/></>)}

                    <label htmlFor="gst_no"className="form-group col-sm-4 text-right  ">GST No </label>
                    <input type="text" id="gst_no" name="gst_no" onChange={ (event) => validate_items(event.target.name,event.target.value,/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,"invalid GSTNo",setInputs)}  value={inputs.gst_no || ""}className="form-control col-sm-7 "  placeholder="Optional — auto-fills from GST portal when entered" maxLength="15" /><br/>
                    {error.gst_no && (<><strong className="form-group col-sm-12 text-center text-danger" >{error.gst_no}</strong><br/></>)}

                    <label htmlFor="gst_status"className="form-group col-sm-4 text-right">GST Status</label>
                    <input name="gst_status" id="gst_status"  value={inputs.gst_status || ""} style={{cursor:"not-allowed"}}className="form-control col-sm-7" disabled={true} type = "text" /><br/>

                    <label htmlFor="lut_no" className="form-group col-sm-4 text-right">LUT No</label>
                    <input type="text" name="lut_no" id="lut_no"  onChange={handleChange}  
                    value={inputs.lut_no|| ""}className="form-control col-sm-7 " /><br/>
                        
                    <label htmlFor="tan_no" className="form-group col-sm-4 text-right">TAN No.</label>
                    <input type="text" name="tan_no" id="tan_no" onChange={handleChange} 
                    value={inputs.tan_no || ""}className="form-control col-sm-7 "  /><br/>

                    <label htmlFor="is_tcs_applicable" className="form-group col-sm-4 text-right">Is TCS Applicable </label>
                      <select name="is_tcs_applicable" id="is_tcs_applicable" onChange={handleChange} value={inputs.is_tcs_applicable || ""} required className="browser-default custom-select form-control col-sm-7 mandatory-form-control"  >
                        <option value="">Please select</option> 
                        <option value="false">No</option>
                        <option value="true">Yes</option>
                      </select><br/>

                    <label htmlFor="is_tds_deductible" className="form-group col-sm-4 text-right">Is TDS Deductable </label>
                      <select name="is_tds_deductible" id="is_tds_deductible" onChange={handleChange} value={inputs.is_tds_deductible || ""} className="browser-default custom-select form-control col-sm-7 mandatory-form-control"  required>
                        <option value="">Please select</option> 
                        <option value="false">No</option>
                        <option value="true">Yes</option>
                      </select><br/>
                  </div>
                    
                  <div className="form-row table-bordered shadow p-2 my-2 border-secondary p-2 mb-3 bg-blue form-control-panel form-panel-fill" >
                    <h5 className='col-sm-11'><b>Contact Details</b></h5><br/><br/> 
                    <label htmlFor="contact_person" className="form-group col-sm-4 text-right">Contact Person Name</label>
                    <input type="text" name="contact_person" id="contact_person" onChange={handleChange} value={inputs.contact_person || ""} className="form-control col-sm-7"/><br/>
                    
                    <label htmlFor="contact_designation" className="form-group col-sm-4 text-right">Designation</label>
                    <input type="text" name="contact_designation" id="contact_designation" onChange={handleChange} value={inputs.contact_designation || ""} className="form-control col-sm-7"/><br/>
                    
                    <label htmlFor="contact_mobile_no" className="form-group col-sm-4 text-right">Contact Mobile No</label>
                    <input type="text" name="contact_mobile_no" id="contact_mobile_no"  onChange={handleChange} value={inputs.contact_mobile_no || ""} placeholder="0123456789"  className="form-control col-sm-7"/><br/>
                    
                    <label htmlFor="contact_email_id" className="form-group col-sm-4 text-right">Email Id</label>
                    <input type="email" name="contact_email_id" id="contact_email_id" onChange={handleChange} value={inputs.contact_email_id || ""} className="form-control col-sm-7" placeholder="ABC@gmail.com"/><br/>
                    {error.contact_email_id && (<><strong className="form-group col-sm-12 text-center text-danger" >{error.contact_email_id}</strong><br/></>)}
                  </div>
                </Col>
              </Row>

              <RemarksStatusLine remarks={inputs.user_remarks} status={inputs.status} onChange={handleChange} />

                    <div className={`modal site-form-modal-root${showModal ? ' show' : ''}`} tabIndex="-1" style={{ display: showModal ? 'block' : 'none' }}>
                      <div className="modal-dialog modal-xl" style={{ height: "500px"}}>
                        <div className="modal-content">
                          <div className="modal-body display site-form-modal">
                            <Row> 
                              <Col xl={6} lg={12} md={12}> 
                                <div className="form-row table-bordered  shadow p-2 my-2 border-secondary p-2 mb-3 bg-blue form-control-panel site-form-panel">
                                  <label htmlFor="chkbx" className="form-group col-sm-4 text-right">Same as Customer</label>
                                  <label>
                                  <input type="checkbox" id="copycustomerdetails"  name="copycustomerdetails" onChange={(evnt)=>(handleCopyDetails(evnt))} checked={isChecked.chkbx || false}/></label>
              
                                  <h5 className='col-sm-11'><b>Site Details</b></h5><br/><br/>
                                  <SitePincodeLocationFields
                                    cookies={cookies}
                                    values={siteInputs}
                                    onChange={(updates) => setSiteInputs((prev) => ({ ...prev, ...updates }))}
                                    nameField={(
                                      <>
                                        <label htmlFor="site_name" className="form-group col-sm-4 text-right">Name </label>
                                        <input type="text" id='site_name' name="site_name" className="form-control col-sm-7 mandatory-form-control" placeholder="Please fill the name field *"  onChange={handleChangeSite} value={siteInputs.site_name || ""}/>
                                        {error.site_name && (<><strong className="form-group col-sm-12 text-center text-danger" >{error.site_name}</strong><br/></>)}
                                      </>
                                    )}
                                  />
                                  {error.site_pincode && (<><strong className="form-group col-sm-12 text-center text-danger" >{error.site_pincode}</strong><br/></>)}
                                                              
                                  <label htmlFor="state"className="form-group col-sm-4 text-right  ">State</label>
                                  <select id="state"name="state" className="browser-default custom-select form-control col-sm-7 mandatory-form-control" onChange={handleChangeSite}  value={siteInputs.state || ""}>
                                    <option value="">Select State</option>
                                    {
                                      getIndianStates()
                                      .map(indian_state => <option key={indian_state.value} value={indian_state.value}>{indian_state.name}</option>
                                      )
                                    }
                                  </select>
                              
                                  <label htmlFor="phone_number" className="form-group col-sm-4 text-right">Phone No</label>
                                  <input type="text" id='phone_number' name="phone_number"onChange={handleChangeSite} value={siteInputs.phone_number || ""} placeholder="0123456789" className="form-control  col-sm-7"/>
                                
                                  <label htmlFor="mobile_number" className="form-group col-sm-4 text-right">Mobile No</label>
                                  <input type="text" id='mobile_number' name="mobile_number" onChange={handleChangeSite} value={siteInputs.mobile_number || ""} placeholder="0123456789"className="form-control  col-sm-7"/>
                                                            
                                  <label htmlFor="site_email_id" className="form-group col-sm-4 text-right">Email</label>
                                  <input type="site_email" id="site_email_id" name="site_email_id"  onChange={ (event) => validate_items(event.target.name,event.target.value,/^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/,"invalid cusEmailid",setSiteInputs)} value={siteInputs.site_email_id|| ""} className="form-control col-sm-7 " />
                                  {error.site_email_id && (<><strong className="form-group col-sm-12 text-center text-danger" >{error.site_email_id}</strong><br/></>)}
                                </div>
                              </Col>
                              <Col xl={6} lg={12} md={12}> 
                                <div className="form-row table-bordered shadow p-2 my-2 border-secondary p-2 mb-3 bg-blue form-control-panel site-form-panel">
                                  <h5 className='col-sm-11'><b>Site Contact Details</b></h5><br/>
                                  <label htmlFor="project_name" className="form-group col-sm-4 text-right">Project Name </label>
                                  <input type="text" name="project_name" id="project_name"onChange={handleChangeSite} value={siteInputs.project_name || ""} className="form-control  col-sm-7 mandatory-form-control" placeholder="Please fill the project name field *" />

                                  <label htmlFor="site_salesrep_id" className="form-group col-sm-4 text-right">Marketing Name </label>
                                  <div style={{ width: '58%' }}>
                                    <Select
                                      id="site_salesrep_id"
                                      options={salesRep}
                                      isMulti={false}
                                      isSearchable={true}
                                      value={salesRep.find((r) => String(r.value) === String(siteInputs.salesrep_id || '')) || null}
                                      onChange={(selected) => setSiteInputs((prev) => ({
                                        ...prev,
                                        salesrep_id: selected?.value || '',
                                      }))}
                                      className="mandatory-form-control react-select-dropdown"
                                      placeholder="Select sales person"
                                    />
                                  </div>
                                  <br />
                                  
                                  <label htmlFor="contact_person" className="form-group col-sm-4 text-right">Contact Person</label>
                                  <input type="text" id='contact_person'name="contact_person"onChange={handleChangeSite} value={siteInputs.contact_person || ""} className="form-control  col-sm-7"/>
                                  
                                  <label htmlFor="contact_designation" className="form-group col-sm-4 text-right">Designation</label>
                                  <input type="text"id='contact_designation' name="contact_designation"onChange={handleChangeSite} value={siteInputs.contact_designation || ""} className="form-control  col-sm-7"/>
                
                                  <label htmlFor="site_contact_email_id" className="form-group col-sm-4 text-right">Email</label>
                                  <input type="text" id='site_contact_email_id' name="site_contact_email_id"  onChange={ (event) => validate_items(event.target.name,event.target.value,/^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/,"invalid CuscontactEmailId",setSiteInputs)} value={siteInputs.site_contact_email_id || ""}className="form-control  col-sm-7"/>
                                  {error.site_contact_email_id && (<><strong className="form-group col-sm-12 text-center text-danger" >{error.site_contact_email_id}</strong><br/></>)}

                                  <label htmlFor="contact_mobile_no" className="form-group col-sm-4 text-right" >Mobile No</label>
                                  <input type="text" id='contact_mobile_no' name="contact_mobile_no"onChange={handleChangeSite} value={siteInputs.contact_mobile_no || ""} placeholder="0123456789" className="form-control  col-sm-7"/>
                                  
                                  <h5 className='col-sm-11'><b>Statutory Details</b></h5><br/>
                                  <label htmlFor="site_pan_no" className="form-group col-sm-4 text-right">PAN No.</label>
                                  <input type="text"name="site_pan_no" id="site_pan_no" className="form-control col-sm-7" onChange={ (event) => validate_items(event.target.name,event.target.value,/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,"invalid PANNo",setSiteInputs)}  value={siteInputs.site_pan_no || ""}  placeholder="Please fill the PAN field *"  /><br/>
                                  {error.site_pan_no && (<><strong className="form-group col-sm-12 text-center text-danger" >{error.site_pan_no}</strong><br/></>)}

                                  <label htmlFor="site_gst_no"className="form-group col-sm-4 text-right">GST No </label>
                                  <input type="text" id="site_gst_no" name="site_gst_no" onChange={ (event) => validate_items(event.target.name,event.target.value,/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,"invalid GSTNo",setSiteInputs)}  value={siteInputs.site_gst_no || ""}className="form-control col-sm-7 "  placeholder="Optional" maxLength="15" /><br/>
                                  {error.site_gst_no && (<><strong className="form-group col-sm-12 text-center text-danger" >{error.site_gst_no}</strong><br/></>)}

                                  <RemarksStatusLine remarks={siteInputs.user_remarks} status={siteInputs.status} onChange={handleChangeSite} />
                                </div> 
                              </Col>
                            </Row>                   
                          </div>
                          <div className="text-center site-form-modal-footer">
                            <button type="button" className="btn btn-primary" onClick={handleModalClose}>
                              {editIndex !== null ? "Update" : "Add"}
                            </button>
                            <button type="button" className="btn btn-primary" onClick={() => setShowModal(false)}>Close</button>
                          </div>
                        </div>
                      </div>
                    </div>

            <div className="form-row table-bordered shadow p-2 my-2 border-secondary p-2 mb-3 bg-blue table-responsive no-column-freeze site-docs-table-wrap form-control-panel">
              <table className="table site-docs-table">
                <thead>
                  <tr>
                    <th className="col-site-name">Site Name</th>
                    <th className="col-project-name">Project / Site Name</th>
                    <th className="col-marketing-name">Marketing Name</th>
                    <th>Address</th>
                    <th>Contact No.</th>
                    <th className="col-distance">Distance (KM)<br />Up &amp; Down</th>
                    <th className="col-est-time">Est. Time<br />to Reach</th>
                    <th className="col-doc-count">Quotation</th>
                    <th className="col-doc-count">Sales Order</th>
                    <th className="col-doc-count">Schedules</th>
                    <th className="col-doc-count">Design Mix</th>
                    <th className="col-doc-count">Delivery Challan</th>
                    <th className="col-doc-count">Invoice</th>
                    <th className="site-docs-actions">
                      <button type="button" className="btn btn-success" onClick={openAddModal}>+</button>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {siteData.map((site,index) => (
                    <tr key={index} >
                      <td className="col-site-name">{site.site_name}</td>
                      <td className="col-project-name">{site.project_name}</td>
                      <td className="col-marketing-name">{
                        salesRep.find((r) => String(r.value) === String(site.salesrep_id || site.salesrep?.id || ''))?.label
                        || site.salesrep?.name
                        || ''
                      }</td>
                      <td className="site-docs-address">{formatSiteAddress(site)}</td>
                      <td>{formatSiteContact(site)}</td>
                      <td className="col-distance">{site.radius_distance ?? ''}</td>
                      <td className="col-est-time">{site.estimated_travel_mins
                        ? `${site.estimated_travel_mins} min`
                        : ''}</td>
                      <td><SiteDocCountCell site={site} docType="quotation" onOpen={() => {}} /></td>
                      <td><SiteDocCountCell site={site} docType="sales_order" onOpen={() => {}} /></td>
                      <td><SiteDocCountCell site={site} docType="schedule" onOpen={() => {}} /></td>
                      <td><SiteDocCountCell site={site} docType="design_mix" onOpen={() => {}} /></td>
                      <td><SiteDocCountCell site={site} docType="delivery_challan" onOpen={() => {}} /></td>
                      <td><SiteDocCountCell site={site} docType="invoice" onOpen={() => {}} /></td>
                      <td className="site-docs-actions">
                        <div className="site-docs-action-btns">
                          <button
                            type="button"
                            className="site-edit-btn"
                            title="Edit site"
                            onClick={(event) => {
                              event.preventDefault();
                              event.stopPropagation();
                              openEditModal(index);
                            }}
                          >
                            <EditSharpIcon sx={{ fontSize: '16px', color: 'white' }} />
                          </button>
                          <button
                            type="button"
                            className="site-delete-btn"
                            title="Delete site"
                            onClick={() => deleteTableSiteRows(index)}
                          >
                            ×
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            
            <div className="footer text-center">
              <Button  type="submit"  style={{width:"80px",fontWeight:"bold",backgroundColor:"RGB(42,245,39,0.8)"}} className="btn btn-twitter">Save</Button> &nbsp;&nbsp;
              <Button type="button"  style={{width:"80px",fontWeight:"bold",backgroundColor:"RGB(58,29,238,0.8)"}} className="btn btn-twitter" onClick={Cancel}>Reset</Button> &nbsp;&nbsp;
              <Button  type="button"style={{width:"80px",fontWeight:"bold",backgroundColor:"RGB(58,29,238,0.8)"}} className="btn btn-twitter" onClick={view}>View</Button>&nbsp;&nbsp;
              <Button  type="button"style={{width:"80px",fontWeight:"bold",backgroundColor:"RGB(58,29,238,0.8)"}} className="btn btn-twitter" onClick={Back}>Home</Button>
            </div>
            </div>
          </form>
          </div>
        </div>
      </div>
    </>
    );
  }
  export default CustomerMain;
